import { AutosuggestProps } from '@amzn/awsui-components-react';
import { AutocompleteResult } from '@amzn/red-velvet-api';
import { getClient } from '../utils/getClient';

export async function loadCauseSuggestions(
  searchText: string,
  featureFlags: string[]
): Promise<AutosuggestProps.Option[]> {
  const client = getClient(featureFlags);
  const response = await client.causeSearchAutocomplete({ searchString: searchText });
  const causeSuggestions = response.results || [];
  const causeSuggestionOptions: AutosuggestProps.Option[] = causeSuggestions.map(
    (causeOption: AutocompleteResult) => ({ value: causeOption.reference, label: causeOption.term })
  );
  return causeSuggestionOptions;
}
